import { styled } from 'stitches.config'
import { Box } from 'components/Box'
import { FixedSizeList } from 'react-window'

export const ContainerWrapper = styled(Box, {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 'auto',
  })
  
export const RowWrapper = styled('div', {
  color: '$accent-black',
  background: '$accent-white',
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '16px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  '&:hover': {
    backgroundColor: '$accent-white',
  },
  '&:active': {
    backgroundColor: '$accent-white',
  }
})

export const SearchWrapper = styled('div', {
  width: '100%',
  maxWidth: '500px',
})

export const List = styled(FixedSizeList, {
  '&:hover': {
    cursor: 'pointer',
  },
})

export const InputWrapper = styled('div', {
  '& > div > div > div' : {marginTop: '0px !important',}
})